export default "__VITE_ASSET__6c43ea03__"